export var SDK;
(function (SDK) {
    SDK["NAME"] = "@heimdallr-sdk";
})(SDK || (SDK = {}));
export var TAG = "[".concat(SDK.NAME, "]:");
